"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledSystem = require("styled-system");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var iconSize = (0, _styledSystem.variant)({
  key: 'iconSizes',
  prop: 'iconSize'
});
var iconColor = (0, _styledSystem.style)({
  // React prop name
  prop: 'fill',
  // The corresponding CSS property (defaults to prop argument)
  cssProperty: 'color',
  // Key for theme values
  key: 'colors'
});
var iconStroke = (0, _styledSystem.style)({
  // React prop name
  prop: 'stroke',
  // The corresponding CSS property (defaults to prop argument)
  cssProperty: 'stroke',
  // Key for theme values
  key: 'colors'
});

var IconBase = function IconBase(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      name = _ref.name,
      fill = _ref.fill,
      stroke = _ref.stroke,
      iconSize = _ref.iconSize,
      props = _objectWithoutProperties(_ref, ["children", "icon", "name", "fill", "stroke", "iconSize"]);

  return /*#__PURE__*/_react["default"].createElement(_Box["default"], _extends({
    stroke: props.stroke,
    fill: props.fill,
    iconSize: props.iconSize
  }, props), icon || children);
};

var Icon = (0, _styledComponents["default"])(IconBase)(_templateObject(), iconSize, iconColor, iconStroke);
Icon.defaultProps = {
  iconSize: 'medium',
  display: 'inline-flex',
  alignItems: 'center'
};
var _default = Icon;
exports["default"] = _default;